export default __webpack_public_path__ + "static/media/Icon_fusion.98dfbf2a.svg";